import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "panel-item"
};
var _hoisted_2 = {
  class: "panel-left"
};
var _hoisted_3 = {
  class: "panel-right"
};
export default {
  __name: 'index',
  props: {
    toolContent: {
      type: String,
      default: '面板'
    },
    svgName: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_t_icon = _resolveComponent("t-icon");
      var _component_t_tooltip = _resolveComponent("t-tooltip");
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("span", null, [_renderSlot(_ctx.$slots, "panelName")]), _createVNode(_component_t_tooltip, {
        theme: "default",
        placement: "bottom",
        showArrow: false,
        content: __props.toolContent
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_icon, {
            name: "help-circle",
            class: "help-circle"
          })];
        }),
        _: 1
      }, 8, ["content"])]), _createElementVNode("div", null, [_renderSlot(_ctx.$slots, "panelNumber")])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_svg_icon, {
        size: 32,
        name: __props.svgName
      }, null, 8, ["name"])])]);
    };
  }
};